import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { IncentiveFormatBaseComponent } from './incentiveFormatBase.component';

@Component({
    'selector': 'incentive-format2',
    'standalone': true,
    template: `
        <div class="format2-container">
            <h2>{{ heading }}</h2>
            <div class="card-grid">
                @for (incentive of incentives; track $index) {
                    <ion-card>
                        <ion-card-header>
                            <ion-card-title>{{ incentive.title }}</ion-card-title>
                        </ion-card-header>
                        <ion-card-content>
                            @if (incentive.line1) {
                                <p>{{ incentive.line1 }}</p>
                            }
                            @if (incentive.line2) {
                                <p>{{ incentive.line2 }}</p>
                            }
                            @if (incentive.note) {
                                <p class="note"><em>{{ incentive.note }}</em></p>
                            }
                        </ion-card-content>
                    </ion-card>
                }
            </div>
        </div>
    `,
    'styles': [
        `
        .card-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            gap: 16px;
        }

        .note {
            font-style: italic;
            color: var(--ion-color-medium);
            margin-top: 8px;
        }
    `
    ],
    'imports': [ IonicModule ]
})
export class IncentiveFormat2Component extends IncentiveFormatBaseComponent {
    public override heading = 'Incentives - Card Grid Format';
}
